<template>
  <sidebar-item-header class="pc-note__openedlist-header" :name="name">已打开</sidebar-item-header>
</template>

<script>
// import IconFont from '@/components/icon/Font.vue'
// import IconEllipsisH from '@/components/icon/EllipsisH.vue'
// import IconClock from '@/components/icon/Clock.vue'
// import { createPopper } from '@popperjs/core'
import SidebarItemHeader from '@/components/note/sidebar/SidebarItemHeader.vue'

export default {
  components: {
    // IconFont,
    // IconEllipsisH,
    // IconClock,
    SidebarItemHeader
  },
  data () {
    return {
      name: 'opened',
      moreActions: {
        contextmenu: {
          type: 'WORKBENCH_SIDEBAR_OPENED_MORE',
          data: {}
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__sidebar .pc-note__openedlist-header {
  top: 5.3rem;
  bottom: -0.1rem;
}
.pc-note__sidebar.notebook.note {
  .pc-note__openedlist-header {
    top: 10.7rem;
    bottom: -0.1rem;
  }
}

</style>
